import FormControlLabel from '@mui/material/FormControlLabel';
import { Checkbox } from '@mui/material';
import { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setItemWebStorage } from '../../features/webStorageSaver';
import { useAppSelector } from '../../stateManagement/hooks/redux';
import { setLastYearsMapFilters } from '../../stateManagement/reducers/MapFiltersSlice';
import ContentHeader from '../../widgets/contentHeader/ContentHeader';

const currentYear = new Date().getFullYear();
const colorPalette = ['#cea11f', '#e15112', '#9820dd', '#1d4cc5', '#14c7c5', '#4b9305', '#999999'];
const defaultPagePrompt = 'ВЫБЕРИТЕ ГОДА ДИАГНОСТИКИ:';

type LastYearWithColor = {
    year: number;
    color: string;
};

const fallbackYearColor = colorPalette[colorPalette.length - 1] ?? '#ebebeb';

export function getLastYearsWithColors(numberOfYears: number): LastYearWithColor[] {
    return Array.from({ length: Math.max(0, numberOfYears) }, (_, index) => {
        const year = currentYear - index;
        const color = colorPalette[index] ?? fallbackYearColor;
        return { year, color };
    })
}

export function buildYearsEnv(numberOfYears: number): string {
    return getLastYearsWithColors(numberOfYears)
        .flatMap(({ year, color }, index) => [
            `year${index}:${year}`,
            `color${index}:${color}`,
        ])
        .join(';');
}

export function getCheckedLastYears(yearFilter: any) {
    return Object.entries(yearFilter ?? {})
        .filter(([, checked]: any) => checked)
        .map(([year]) => year);
}

export function getLastYearsFalseCqlFilter(fieldName = 'EventYear') {
    return `(${fieldName} IS NULL and ${fieldName} IS NOT NULL)`;
}

export function getLastYearsCqlFilter(yearFilter: any, fieldName = 'EventYear') {
    const checkedYears = getCheckedLastYears(yearFilter);
    if (checkedYears.length === 0) {
        return getLastYearsFalseCqlFilter(fieldName);
    }
    return `${fieldName} in (${checkedYears.join(',')})`;
}

export function LastYearsMapFilter({ filterType, numberOfYears, objectType, pagePrompt = defaultPagePrompt }: any) {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const lastYearsMapFilters = useAppSelector(state => state.mapFilters.lastYearsMapFilters)

    useEffect(() => {
        if (!lastYearsMapFilters?.[objectType]) {
            resetYearsMapFilter()
        }
    }, [objectType])

    function changeYearsMapFilter(event: any) {
        const { name, checked } = event.target;
        const newLastYearsMapFilters = { ...lastYearsMapFilters, [objectType]: { ...lastYearsMapFilters?.[objectType], [name]: checked } }
        dispatch(setLastYearsMapFilters(newLastYearsMapFilters))
        setItemWebStorage('lastYearsMapFilters', newLastYearsMapFilters)
    }

    function resetYearsMapFilter() {
        const newLastYearsMapFilters = { ...lastYearsMapFilters, [objectType]: { [currentYear]: true } }
        dispatch(setLastYearsMapFilters(newLastYearsMapFilters))
        setItemWebStorage('lastYearsMapFilters', newLastYearsMapFilters)
    }

    return (
        <>
            {filterType === 'page' &&
                <>
                    <ContentHeader title="Настройка фильтров" />
                    <div className="last-years-map-filter-page-div">
                        <div className="apply-filters-header mt-3 mb-2">
                            <span>{pagePrompt}</span>
                        </div>
                        <hr></hr>
                        <div className="checkboxes-div">
                            {getLastYearsWithColors(numberOfYears).map(({ year, color }: any) => (
                                <FormControlLabel
                                    className="checkbox-label"
                                    key={year}
                                    name={year}
                                    label={year}
                                    checked={!!lastYearsMapFilters?.[objectType]?.[year]}
                                    onChange={changeYearsMapFilter}
                                    color={color}
                                    control={<Checkbox className="ch-white" style={{ color }} />}
                                />
                            ))}
                        </div>
                        <hr></hr>
                        <div className="buttons-div">
                            <Button className="apply-filters-button" onClick={() => navigate(-1)}>Применить</Button>
                            <Button className="reset-filters-button" onClick={resetYearsMapFilter}>Сбросить</Button>
                        </div>
                    </div>
                </>
            }
            {filterType === 'header' &&
                <div className="last-years-map-filter-header-div">
                    <div className="checkboxes-div">
                        {getLastYearsWithColors(numberOfYears).map(({ year, color }: any) => (
                            <FormControlLabel
                                className="checkbox-label"
                                key={year}
                                name={year}
                                label={year}
                                checked={!!lastYearsMapFilters?.[objectType]?.[year]}
                                onChange={changeYearsMapFilter}
                                color={color}
                                control={<Checkbox className="ch-white" style={{ color }} />}
                            />
                        ))}
                    </div>
                </div>
            }
        </>
    );
}
